import React, { useState } from 'react';
import { editPost } from '../services/postService';
import './EditPostForm.css';

const EditPostForm = ({ post, currentUser, onEditComplete, onCancel }) => {
  const [text, setText] = useState(post.text);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      setError('Post cannot be empty');
      return;
    }

    if (text.trim().length > 500) {
      setError('Post is too long. Maximum 500 characters allowed.');
      return;
    }

    if (text.trim() === post.text.trim()) {
      onCancel(); // No changes made
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await editPost(post.id, text, currentUser.uid);
      onEditComplete();
    } catch (error) {
      setError('Failed to edit post: ' + error.message);
      console.error('Error editing post:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setText(post.text); // Reset to original text
    setError('');
    onCancel();
  };

  return (
    <div className="edit-post-form">
      <form onSubmit={handleSubmit}>
        <div className="edit-form-group">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows="3"
            disabled={isSubmitting}
            maxLength="500"
            autoFocus
          />
          <div className="edit-character-count">
            {text.length}/500
          </div>
        </div>

        {error && <div className="edit-error-message">{error}</div>}

        <div className="edit-form-actions">
          <button 
            type="submit" 
            className="edit-save-button"
            disabled={isSubmitting || !text.trim()}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
          <button 
            type="button" 
            className="edit-cancel-button"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditPostForm;